import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useConnectWallet } from '../../hooks/useConnectWallet'
import { isCorrectNetwork } from '../../utils'
import { getWithExpiry, setWithExpiry } from '../../utils/localstoageHelper'
import './style.scss'

const expire = 60 * 24 * 365 * 60000 // 1 year

const LandingPage = () => {
  const { account, connectWallet, chainId, library } = useConnectWallet()

  const { ref } = useParams<any>()

  useEffect(() => {
    const refCode = getWithExpiry('refCode')
    if (!refCode || refCode !== ref) {
      setWithExpiry('refCode', ref, expire)
    }
  }, [])

  return (
    <div className='affiliate-page'>
      <div className='container'>
        <div className='header'>
          <h1 className='title head-title'>Welcome to refer program</h1>
          <p className='sub-title'>
            Stake and become affiliate to get more benefit or just swap!
          </p>

          <Link to={`/affiliateProgarm/${ref}`}>
            <span className='btn secondary-btn  btn-refer'>
              Become affiliate
            </span>
          </Link>

          <Link to={`/swap/${ref}`}>
            <span className='btn secondary-btn  btn-refer'>Swap now</span>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default LandingPage
